
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import { ValidationProvider, extend } from 'vee-validate';

import { required } from 'vee-validate/dist/rules';

import { AddressBookAirRoadStop } from '@/models/addressBook';

extend('required', {
  ...required,
  message: 'This field is required',
});

@Component({
  components: {
    ValidationProvider,
  },
})
export default class LookupAddresses extends Vue {
  @Prop({ type: Array, required: true }) public addressData: AddressBookAirRoadStop[];
  @Prop({ type: String, required: true }) public name: string;

  public loading = false;

  public addressValue = '';
  public selectItems: string[] = [];

  public showOptions = false;
  public addressChosen: AddressBookAirRoadStop = {
    city: null,
    line1: '',
    line2: '',
    line3: null,
    name: '',
    suburb: {
      id: 0,
      name: '',
      postcode: '',
      state: '',
    },
    id: 0,
    warehouse: false,
  };
  private addressChosenDefault: AddressBookAirRoadStop = { ...this.addressChosen };

  public arrowIdx = -1;

  @Watch('addressChosen', { deep: true })
  private watchAddressChosen() {
    this.$emit('changed', this.addressChosen, this.name.slice(-1));
  }

  private applyValueFromParent(item: AddressBookAirRoadStop): void {
    this.addressChosen = item;
    this.showOptions = false;
    this.addressValue = item.name;
    this.$forceUpdate();
  }

  public handleInput(evt: string): void {
    const filterdAdresses = this.addressData.filter(
      x => `${x.name}, ${x.suburb.name}`.toUpperCase().indexOf(evt.toUpperCase()) >= 0,
    );
    this.selectItems = [...filterdAdresses.map(address => `${address.name}, ${address.suburb.name}`)];
    this.$emit('changed', evt, this.name.slice(-1));
  }

  public inputKeyPressed(evt: KeyboardEvent): void {
    // Open dropdown on Focus
    if (!this.showOptions) {
      this.showOptions = true;
      this.arrowIdx = -1;
    }
    // Close dropdown when "Escape" pressed
    if (evt.code === 'Escape') {
      this.showOptions = false;
      this.arrowIdx = -1;
    }
    // ArrowDown / ArrowUp pressed
    if (evt.code === 'ArrowDown' && this.arrowIdx < this.selectItems.length - 1) {
      this.arrowIdx += 1;
      this.fixScrolling();
    }
    if (evt.code === 'ArrowUp' && this.arrowIdx >= 1) {
      this.arrowIdx -= 1;
      this.fixScrolling();
    }
    // Enter pressed
    if (evt.code === 'Enter' && this.arrowIdx >= 0) {
      evt.preventDefault();
      const chosenAddress = this.addressData.find(
        x => `${x.name}, ${x.suburb.name}`.substring(0, 30) === this.selectItems[this.arrowIdx].substring(0, 30),
      );
      if (chosenAddress) {
        this.addressChosen = chosenAddress;
        this.showOptions = false;
        this.addressValue = this.selectItems[this.arrowIdx];
        this.arrowIdx = -1;
      }
    }
  }

  private fixScrolling() {
    const options = this.$refs.options as HTMLFormElement;
    const scrollContainer = this.$refs.scrollContainer as HTMLFormElement;
    if (options && scrollContainer) {
      const liH = options[this.arrowIdx].clientHeight;
      scrollContainer.scrollTop = liH * this.arrowIdx;
    }
  }

  public clearInput(): void {
    this.addressValue = '';
    this.showOptions = false;
    this.addressChosen = { ...this.addressChosenDefault };
    this.addressChosen.warehouse = false;
    this.arrowIdx = -1;
    this.selectItems = [];
  }

  public inputFocused(): void {
    this.showOptions = true;
    this.selectItems = this.addressData.map(address => `${address.name}, ${address.suburb.name}`);
  }

  public inputBlured(): void {
    setTimeout(() => {
      this.showOptions = false;
    }, 200);
  }

  public handleItemClick(item: string): void {
    const chosenAddress = this.addressData.find(
      x => `${x.name}, ${x.suburb.name}`.substring(0, 30) === item.substring(0, 30),
    );
    if (chosenAddress) {
      this.addressChosen = chosenAddress;
      this.showOptions = false;
      this.addressValue = item;
    }
  }

  public clickedOutside(): void {
    this.showOptions = false;
  }
}
